import ResponsiveImage from '~/components/Image/ResponsiveImage'

export default function GeoGebraNoDescription(): React.ReactElement {
  return (
    // there are no translations for this. It is only for the Norwegian version of the GeoGebra page
    <div className="w-full max-w-5xl mx-auto my-6 p-5 rounded gradient-border-container">
      <div className="bg-white w-full h-full p-4 space-y-5">
        <p>
          Her finner du oppskrifter til GeoGebra5. Det finnes en nyere versjon, GeoGebra6, men da denne versjonen er
          ustabil for mange, anbefales det å bruke GeoGebra 5.
        </p>

        <div className="flex flex-col md:flex-row gap-5">
          <ResponsiveImage
            className="flex-none w-full max-w-85"
            height={261}
            imageWidths="340"
            srcKey="misc/geogebra.png"
            width={340}
          />
          <div className="space-y-5">
            <p>
              I ulike versjoner, vil du kunne finne menyen et annet sted enn avbildet i guiden. Hos noen er menyen til
              GeoGebra-feltene helt oppe i menylinjen på toppen av skjermen din. Da trykker du på vis, og finner feltene
              der.
            </p>
            <p className="flex-grow">
              Dersom du ikke finner akkurat det navnet på et verktøy du er ute etter, skal du lete etter synonymer. «
              <b>fra</b>» er andre steder kalt «<b>startverdi</b>» eller «<b>start</b>». «<b>til</b>» kalles også «
              <b>sluttverdi</b>» eller «<b>slutt</b>». Det viktige er å lete etter det verktøyet som har alle elementene
              du trenger.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
